import { useLocation, useNavigate } from "react-router-dom";
import { useSessionsPage } from "../../api/api-hooks";
import { createColumnHelper } from "@tanstack/react-table";
import ReactTanstackTableUi from "../../common/ReactTanstackTableUi";
// import { FaTrashAlt, FaEye } from "react-icons/fa";
import { formatDateTimeAndYear, formatDuration } from "../../utils/date-utils";
import { useAdminData } from "../../lib/useAdminData";
import { useMemo } from "react";
import {
  filterDataByDate,
  getDateRangeFromSelectedValue,
} from "../../common/Constants";
import useCommonStore from "../../store/CommonStore";
import { usePagination } from "../hooks/usePagination";

function prepareColumns(columnHelper: any, handleActions: any) {
  return [
    columnHelper.accessor((row: any) => `${row.username} ${row.user_email}`, {
      id: "username",
      cell: (info: any) => {
        const original = info.row.original;
        console.log("original", original);

        return (
          <div className=" text-gray-800 text-base truncate space-y-1  ">
            <div className="font-medium text-gray-900 text-sm leading-5">
              {original?.username || "--"}
            </div>
            <div className=" w-32  text-xs text-gray-500  ">
              {original?.user_email || "--"}
            </div>
          </div>
        );
      },
      header: () => <div>Name</div>,
    }),

    // columnHelper.accessor((row: any) => row.lastSessionIp, {
    //   id: "lastSessionIp",
    //   cell: (info: any) => {
    //     const original = info?.row?.original;

    //     return (
    //       <div className="flex flex-col gap-1">
    //         {original.last_session_ip ? (
    //           <div className="font-semibold text-gray-800 text-base max-w-xs">
    //             {original.last_session_ip}
    //           </div>
    //         ) : (
    //           <div className="flex justify-center items-center min-h-[1.5rem] w-full">
    //             --
    //           </div>
    //         )}
    //       </div>
    //     );
    //   },
    //   header: () => <div>Last Session IP</div>,
    // }),

    // columnHelper.accessor((row: any) => row.lastTimeAskedQuestion, {
    //   id: "lastTimeAskedQuestion",
    //   cell: (info: any) => {
    //     const original = info?.row?.original;

    //     return (
    //       <div className="flex flex-col gap-1">
    //         {/* {users.map((user: any, index: number) => (
    //           <div
    //             key={index}
    //             className="font-semibold text-gray-800 text-base max-w-xs"
    //           >
    //             {user.last_time_asked_question &&
    //             user.last_time_asked_question !== "No prompt asked yet"
    //               ? (() => {
    //                   const { date, time } = formatDateTimeAndYear(
    //                     user.last_time_asked_question
    //                   );
    //                   return `${date} ${time}`;
    //                 })()
    //               : "--"}
    //           </div>
    //         ))} */}

    //         {original?.last_time_asked_question ? (
    //           (() => {
    //             const { date, time } = formatDateTimeAndYear(
    //               original.last_time_asked_question
    //             );
    //             return `${date} ${time}`;
    //           })()
    //         ) : (
    //           <div className="flex justify-center items-center min-h-[1.5rem] w-full">
    //             --
    //           </div>
    //         )}
    //       </div>
    //     );
    //   },
    //   header: () => <div>Last Activity</div>,
    // }),

    // columnHelper.accessor((row: any) => row.ipAddress, {
    //   id: "ipAddress",
    //   cell: (info: any) => {
    //     const original = info?.row?.original;

    //     return (
    //       <div className="flex flex-col gap-1">
    //         <div className="font-semibold text-gray-800 text-base max-w-xs">
    //           {Array.isArray(original.country) &&
    //           original.country.length > 0 ? (
    //             original.country[0]
    //           ) : (
    //             <div className="flex justify-center items-center min-h-[1.5rem] w-full">
    //               --
    //             </div>
    //           )}
    //         </div>
    //       </div>
    //     );
    //   },
    //   header: () => <div>Current session IP</div>,
    // }),

    columnHelper.accessor((row: any) => row.country, {
      id: "country",
      cell: (info: any) => {
        const original = info?.row?.original;

        return (
          <div className="font-normal text-gray-900 text-sm whitespace-nowrap leading-5">
            {Array.isArray(original?.country) && original.country.length > 1 ? (
              original.country[1]
            ) : typeof original?.country === "string" ? (
              original.country
            ) : (
              <div className="flex justify-center items-center w-full">--</div>
            )}
          </div>
        );
      },
      header: () => <div>Location</div>,
    }),

    columnHelper.accessor((row: any) => row.loginTime, {
      id: "loginTime",
      cell: (info: any) => {
        const original = info?.row?.original;

        return (
          <div>
            {original?.login_time ? (
              (() => {
                const { date, time } = formatDateTimeAndYear(
                  original.login_time
                );
                return (
                  <div className=" text-gray-900 text-sm leading-5 ">
                    {`${date} ${time}`}
                  </div>
                );
              })()
            ) : (
              <div className="flex justify-center items-center ">--</div>
            )}
          </div>
        );
      },
      header: () => <div>Last Logged in </div>,
    }),

    columnHelper.accessor((row: any) => row.logoutTime, {
      id: "logoutTime",
      cell: (info: any) => {
        const original = info?.row?.original;

        return (
          <div>
            {original?.logout_time ? (
              (() => {
                const { date, time } = formatDateTimeAndYear(
                  original.logout_time
                );
                return (
                  <div className="font-normal text-gray-900 text-sm leading-5 ">
                    {`${date} ${time}`}
                  </div>
                );
              })()
            ) : (
              <div className="font-normal text-gray-900 text-sm leading-5">
                --
              </div>
            )}
          </div>
        );
      },
      header: () => <div>Logout </div>,
    }),

    columnHelper.accessor((row: any) => row.totalClicks, {
      id: "totalClicks",
      cell: (info: any) => {
        const original = info?.row?.original;
        const userActivity = original?.user_activity || [];

        const totalClicks = userActivity.reduce(
          (acc: number, activity: any) => acc + (activity.total_hits || 0),
          0
        );

        return (
          <div className="font-normal text-gray-900 text-sm leading-5 text-center">
            {totalClicks}
          </div>
        );
      },
      header: () => <div className="text-center">User Engagement</div>,
    }),

    // columnHelper.accessor((row: any) => row.TimeSpent, {
    //   id: "TimeSpent",
    //   cell: (info: any) => {
    //     const original = info?.row?.original;
    //     const userActivity = original?.user_activity || [];

    //     const totalTimeSpent = userActivity.reduce(
    //       (acc: number, activity: any) =>
    //         acc + (activity.total_time_spent || 0),
    //       0
    //     );

    //     console.log("totalTimeSpent", totalTimeSpent);

    //     return (
    //       <div className="font-semibold text-gray-800 text-base text-center">
    //         {formatDuration(totalTimeSpent)}
    //       </div>
    //     );
    //   },
    //   header: () => <div className="text-center">Time Spent (HH:MM:SS)</div>,
    // }),

    columnHelper.accessor((row: any) => row.totalClicks, {
      id: "user_login_count",
      cell: (info: any) => {
        const original = info?.row?.original;

        return (
          <div className="font-normal text-gray-900 text-sm leading-5 text-center">
            {original.user_login_count || 0}
          </div>
        );
      },
      header: () => <div className="text-center">Login Count</div>,
    }),

    columnHelper.accessor((row: any) => row.sessionDuration, {
      id: "sessionDuration",
      cell: (info: any) => {
        const original = info?.row?.original;

        return (
          <div className="flex flex-col gap-1">
            {original?.session_duration ? (
              <div
                className="font-normal text-gray-900 text-sm leading-5
              max-w-xs"
              >
                {formatDuration(original.session_duration)}
              </div>
            ) : (
              <div className="font-normal text-gray-900 text-sm leading-5">
                --
              </div>
            )}
          </div>
        );
      },
      header: () => <div>Total average time/session</div>,
    }),

    columnHelper.accessor((row: any) => row.device, {
      id: "device",
      cell: (info: any) => {
        const original = info?.row?.original;

        const isMobileDevice = () => {
          if (typeof window === "undefined") return "Unknown";
          const userAgent = navigator.userAgent || navigator.vendor;

          return /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent)
            ? "Mobile"
            : "Desktop";
        };

        return (
          <div className="flex flex-col gap-1">
            {original?.user_agent ? (
              <div className="font-normal text-gray-900 text-sm leading-5 max-w-xs">
                {isMobileDevice()}
              </div>
            ) : (
              <div className="font-normal text-gray-900 text-sm leading-5">
                --
              </div>
            )}
          </div>
        );
      },
      header: () => <div>Device</div>,
    }),

    // columnHelper.accessor((row: any) => row.status, {
    //   id: "status",
    //   cell: (info: any) => {
    //     const original = info?.row?.original;

    //     return (
    //       <div className="flex flex-col gap-1">
    //         {original?.status ? (
    //           original.status
    //         ) : (
    //           <div className="flex justify-center items-center min-h-[1.5rem] w-full">
    //             --
    //           </div>
    //         )}
    //       </div>
    //     );
    //   },
    //   header: () => <div>Status </div>,
    // }),

    columnHelper.accessor((row: any) => row.activeSession, {
      id: "Active Session",
      cell: (info: any) => {
        const original = info.row.original;

        return (
          <div className="flex flex-col gap-1">
            {original?.status ? (
              <div className="font-normal text-gray-900 text-sm leading-5 max-w-xs">
                {original?.status}
              </div>
            ) : (
              <div className="font-normal text-gray-900 text-sm leading-5">
                --
              </div>
            )}
          </div>
        );
      },
      header: () => <div>Status</div>,
    }),
  ];
}

function SessionListTable() {
  // const {
  //   data: sessions,
  //   isLoading: isSessionLoading,
  //   // error: chatsError,
  // } = useSessions();

  const { selectedValue } = useCommonStore();

  const dateRange = getDateRangeFromSelectedValue(selectedValue);

  // const { startDate, endDate } = dateRange!;

  const { pageIndex, pageSize, getPaginationInfo } = usePagination();

  const isAllData = dateRange?.isAllData ?? false;
  const startDate = isAllData ? undefined : dateRange?.startDate ?? "";
  const endDate = isAllData ? undefined : dateRange?.endDate ?? "";

  const {
    data: sessions,
    isLoading: isSessionLoading,
    // error: chatsError,
  } = useSessionsPage(pageIndex + 1, pageSize, startDate, endDate, isAllData);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const statusFilter = queryParams.get("status");
  const { activeSessions } = useAdminData();
  const apiData = Array.isArray(sessions?.Sessions) ? sessions?.Sessions : [];

  const filteredUser = statusFilter === "active" ? activeSessions : apiData;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { filteredData } = useMemo(() => {
    return filterDataByDate(filteredUser, selectedValue);
  }, [filteredUser, selectedValue]);

  const paginationInfo = getPaginationInfo(sessions?.Sessions);

  const columnHelper = createColumnHelper();

  const columns = prepareColumns(columnHelper, handleActions);

  const navigate = useNavigate();

  //   const [selectedId, setSelectedId] = useState<string | null>(null);

  //   function handleView(fetchId: string) {}

  //   function handleFetch(fetchType: string, fetchId: string) {
  //     // setType(fetchType);
  //     setSelectedId(fetchId);
  //   }

  function handleActions(fetchType: string, fetchId: string) {
    if (!isSessionLoading && fetchType === "view") {
      navigate(`/chat/${fetchId}`);
    }
    if (!isSessionLoading && fetchType === "delete") {
      // console.log("delete");
    }
  }

  // if (isSessionLoading) {
  //   return <Loader />;
  // }

  return (
    <div className=" ">
      {/* <ReactTanstackTableUi
        data={filteredData}
        columns={columns}
        pagination={filteredData?.length > 10}
        noDataMessage="Sessions"
        tableTitle="Sessions"
      /> */}

      <ReactTanstackTableUi
        data={apiData}
        columns={columns}
        // pagination={apiData?.length > 10}
        noDataMessage="Sessions"
        tableTitle="Sessions"
        disableRowHeight={true}
        pagination={true}
        externalPagination={paginationInfo}
        isLoading={isSessionLoading}
        //   additionalButton={updateUserPermission ? "Invite" : ""}
        // btnUrl={`/${orgId}/users/invite`}
      />
    </div>
  );
}

function Sessions() {
  return (
    <div className=" flex flex-col gap-6 ">
      <div>
        <SessionListTable />
      </div>
    </div>
  );
}

export default Sessions;
